<template>
  <section data-module="featuredItems" :id="data.id">
    <component_bigHeading :data="{heading: data.title, byline: data.byline}" />
    <template v-for="(item, i) in items">
      <div class="featured-item" :key="item.headline" :data-index="i + 1">
        <component_blurb :data="item">
        </component_blurb>
      </div>
    </template>
    <div v-if="data.outlink" class="outlink-wrapper">
      <div class="outlink">
        <a :href="data.outlink.href">
          <div class="copy">
            {{data.outlink.copy}}
            <span data-ornament="arrow--right" />
          </div>
        </a>
      </div>
    </div>
    {{setMasonry()}}
  </section>
</template>

<script>
import works from '@/content/work/index';

export default {
  name: 'module_featuredItems',
  props: ['data', 'window'],
  data() {
    return {
      masonry: {
        breakpoint: [1024, 10000],
        container: '[id="homepageFeaturedWork"]',
        columns: 2,
        set: false,
      },
      preTapCheck: 0,
    };
  },
  computed: {
    items() {
      const refs = this.data.items;
      const itemType = this.data.itemType;
      const window = this.window;

      const items = refs.reduce(function(a, b) {
        if (works[b]) {
          works[b].itemType = itemType;
          a.push(works[b]);
        }

        return a;
      }, []);


      // add window data for use in blurb
      items.forEach(function(item) {
        item.window = window; // eslint-disable-line
      });

      return items;
    },
  },
  methods: {
    setMasonry() {
      // HACK DIY masonry
      const cells = document.querySelectorAll(`${this.masonry.container} > *`);
      if (!cells) { return; }

      let currentCol = 0;
      const cols = [];

      if (this.window.width <= this.masonry.breakpoint[0] || this.window.width > this.masonry.breakpoint[1]) {
        if (!this.masonry.set) {
          return;
        }
        for (let i = 0; i < cells.length; i += 1) {
          // reset margins while we're here
          cells[i].style.marginTop = 0;
        }

        return;
      }

      for (let i = 0; i < cells.length; i += 1) {
        // set up the container if it doesn't exist
        if (!cols[currentCol]) {
          cols[currentCol] = [];
        }

        cols[currentCol].push(cells[i]);

        if (currentCol < this.masonry.columns - 1) {
          currentCol += 1;
        } else {
          currentCol = 0;
        }

        // reset margins while we're here
        cells[i].style.marginTop = 0;
      }

      // Loop through each column, looking back to determine how to space the items
      cols.forEach(function(col) {
        let colHeight = 0;
        for (let i = 0; i < col.length; i += 1) {
          const item = col[i];
          const itemHeight = item.offsetHeight;

          // find out how offset the item is
          const itemOffset = item.offsetTop;

          // masonry effect:
          const diff = colHeight - itemOffset;
          item.style.marginTop = `${diff}px`;

          // add item height to the column
          colHeight += itemHeight;
        }
      });

      this.masonry.set = true;
    },
  },
  mounted: function() {
    setTimeout(this.setMasonry(), 5);
  },
};
</script>

<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_typography.scss';

[data-module="featuredItems"] {
  @include spacer();
  @include grid($subgrid: true);

  @include mq($bp--tablet, up) {
    [data-component="bigHeading"],
    [data-index="2"],
    [data-index="4"] {
      grid-column: 9 / span 4;
    }

    [data-index="1"],
    [data-index="3"] {
      grid-column: 1 / span 7;
    }

    .outlink-wrapper {
      grid-column: 9 / span 4;
    }

    // set spacing via the wrappers
    .heading {
      margin-bottom: rem(120px);
    }

    [data-index="1"] [data-component="blurb"] {
      margin-top: 143px;
      margin-bottom: 144px;
    }

    [data-index="2"] [data-component="blurb"] {
      margin-bottom: 100px;
    }

    // set the blurb heights/widths as necessary
    [data-index="1"] {
      .blurb {
        // height: 408px;
        // padding-bottom: 50%;

        &__background {
          padding-bottom: 50%;
        }
      }
    }

    [data-index="2"] {
      .blurb {
        &__background {
          padding-bottom: 133%;
        }
      }
    }

    [data-index="3"] {
      display: flex;
      justify-content: flex-end;

      [data-component="blurb"] {
        width: 100%;
        max-width: (390/710 * 100%);
      }

      .blurb__background {
        padding-bottom: 150%;
      }
    }

    [data-index="4"] {
      .blurb {
        &__background {
          padding-bottom: 133%;
        }
      }
    }

  }

  @include mq($bp--tablet, down) {
    &[id="homepageFeaturedWork"] {
      display: flex;
      flex-wrap: wrap;
    }

    [data-component="bigHeading"] {
      width: 100%;
    }

    [data-index] {
      width: 50%;
    }

    .blurb {
      padding-bottom: 100%;
    }
  }

  @include mq($bp--sm, down) {
    &[id="homepageFeaturedWork"] {
      padding: 0;

      // maintain heading spacing

      [data-component="bigHeading"] {
        padding: 0 2rem;
      }
    }

    [data-index] {
      width: 100%;
    }
  }

  .outlink-wrapper {
    display: flex;
    align-self: stretch;
  }

  .outlink {
    align-self: flex-end;
    width: 11.5rem;
    height: 11.5rem;
    border-radius: 50%;
    background: $color--primary-highlight;

    a {
      width: 11.5rem;
      height: 11.5rem;
      padding: 0 2rem;

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      text-align: center;
      text-decoration: none;
      color: white;
      @include sansserif();
      font-weight: 400;
      font-size: rem(22px);
      line-height: (28/22);
    }

    [data-ornament] {
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translate(-50%, 75%);
      width: rem(26px);

      @include createOrnament($type: arrow--right);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/featuredItems.vue